module.exports = __webpack_public_path__ + "img/hapoalim.3dd2c05a.svg";